module.exports = __webpack_public_path__ + "static/bandfoto-jan-45c015af0e366fe8ee31a711c228ae68.jpg";